var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonEventsList.jinja');
require('./CommonEventsList.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonEventsList/CommonEventsList.js
// module id = 36
// module chunks = 0